import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnsavedChangesGuard } from '@app/core/guards';
import { AccountStructureResolver } from '@app/shared/resolvers';
import { AccountMassUpdateComponent } from './account-mass-update/account-mass-update.component';
import { ApprovalSetupComponent } from './approval-setup/approval-setup.component';
import { BankingDetailComponent } from './banking-info/bank-detail/bank-detail.component';
import { BankingListComponent } from './banking-info/bank-list/bank-list.component';
import { CoaImportToolComponent } from './coa-import-tool/coa-import-tool.component';
import { NotificationsSetupComponent } from './notifications/notifications-setup.component';
import { PaymentCardSetupComponent } from './payment-card-setup/payment-card-setup.component';
import { PurchaseOrderSetupComponent } from './purchase-order-setup/purchase-order-setup.component';
import { UnitSetupComponent } from './unit-setup/unit-setup.component';

const routes: Routes = [
	{
		path: 'unit-setup',
		component: UnitSetupComponent,
		canDeactivate: [UnsavedChangesGuard],
	},
	{
		path: 'site-setup',
		loadChildren: () => import('./site-setup/site-setup.module').then((m) => m.SiteSetupModule),
	},
	{
		path: 'banking',
		component: BankingListComponent,
		canDeactivate: [UnsavedChangesGuard],
	},
	{
		path: 'banking/:id',
		component: BankingDetailComponent,
		canDeactivate: [UnsavedChangesGuard],
	},
	{
		path: 'purchase-order-setup',
		component: PurchaseOrderSetupComponent,
		canDeactivate: [UnsavedChangesGuard],
	},
	{
		path: 'purchase-card-setup',
		component: PaymentCardSetupComponent,
		canDeactivate: [UnsavedChangesGuard],
	},
	{
		path: 'notifications',
		component: NotificationsSetupComponent,
		canDeactivate: [UnsavedChangesGuard],
	},
	{
		path: 'approval-setup',
		component: ApprovalSetupComponent,
		canDeactivate: [UnsavedChangesGuard],
	},
	{
		path: 'coa-import-wizard',
		component: CoaImportToolComponent,
		canDeactivate: [UnsavedChangesGuard],
	},
	{
		path: 'account-mass-update',
		component: AccountMassUpdateComponent,
		canDeactivate: [UnsavedChangesGuard],
		resolve: {
			accountStructure: AccountStructureResolver,
		},
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class SystemSettingsSystemSetupRoutingModule {}
